module.exports = __webpack_public_path__ + "static/media/15.f39811ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15.jpg
// module id = 190
// module chunks = 0